import React from 'react'

export default ({width, height}) => (
  <svg className="shape shape--upload" width={width} height={height} viewBox="0 0 561 561">
    <path d="M280.5,76.5V0l-102,102l102,102v-76.5c84.15,0,153,68.85,153,153c0,25.5-7.65,51-17.85,71.4l38.25,38.25
			C471.75,357,484.5,321.3,484.5,280.5C484.5,168.3,392.7,76.5,280.5,76.5z M280.5,433.5c-84.15,0-153-68.85-153-153
			c0-25.5,7.65-51,17.85-71.4l-38.25-38.25C89.25,204,76.5,239.7,76.5,280.5c0,112.2,91.8,204,204,204V561l102-102l-102-102V433.5z"
			/>
  </svg>
)


// WEBPACK FOOTER //
// ./src/components/Shapes/Generate.js